import { Injectable } from '@angular/core';
import { LocalStorageService } from '../localStorage/local-storage.service';
import { HttpResponse } from '@angular/common/http';
import { HttpClientService } from '../http-client/http-client.service';
import { EnumStatusResponse } from '../../enums/EnumStatusResponse';
import { Router } from '@angular/router';
import { decodeJwt } from 'jose';

@Injectable({
  providedIn: 'root'
})
export class SessionService {
  private refreshToken: string = '';
  private bearerToken: string = '';
  isValidSession: boolean=false;
  
  constructor(
    private localStorage: LocalStorageService,
    private httpClientService: HttpClientService,
    private router: Router,
   ) {

    this.setTokenReFresh();
    this.setBearerToken();
    this.isValidSession = Boolean(this.localStorage.get("isValidSession"));
  }

  setTokenReFresh(){
    this.refreshToken = String(this.localStorage.get("refreshToken"));   
  }

  setBearerToken(){
    this.bearerToken = String(this.localStorage.get("bearerToken")); 
  }

  getBearerToken():string{
    return String(this.localStorage.get("bearerToken"));
  }

  geTokenReFresh():string{
    return String(this.localStorage.get("refreshToken"));
  }
  
  setSessionStatus(value : boolean){
    this.isValidSession = value;
    if(!this.isValidSession){
      this.router.navigate(['/home']);
    }
  }

  checkSessionIsValid(){

    const tokenUpdate = {
      bearerToken : this.bearerToken,
      refreshToken: this.refreshToken
    };

    /* this.httpClientService
    .refleshToken(tokenUpdate)
    .then((response: HttpResponse<any>)=>{
      if(response.status == EnumStatusResponse.Success) {
        this.bearerToken = String(response.body.bearerToken).replace("Bearer","").trim();
        this.refreshToken = String(response.body.refreshToken).trim();

        this.localStorage.add("bearerToken",this.bearerToken);
        this.localStorage.add("refreshToken",this.refreshToken);
        this.isValidSession = true;

      }else if(response.status == EnumStatusResponse.AccessDenied) {
        this.isValidSession = false;
      }
    })
    .catch(error => {
      console.log(error);
    }) */
  }

  getSessionIsValid():boolean {
    return this.isValidSession;
  }

   isTokenExpired(token: string): boolean {
    try {

      if(token){         
          const payloadBase64 = token; // Obtém a parte do payload
          const payload = decodeJwt(payloadBase64);
          const exp = payload?.exp || 0 ; // Obtém o timestamp de expiração (em segundos)
          const now = Math.floor(Date.now() / 1000); // Obtém o timestamp atual (em segundos)
          
          return exp < now;
      }
      return true;
     
    } catch (error) {
      console.error('Erro ao decodificar o token:', error);
      return true; // Caso o token esteja inválido, considere-o expirado
    }
  }
}
